import LTR from "@brand-icons/global/social-facebook-messenger/social-facebook-messenger-ltr.svg";

import { iconFactory } from "../iconFactory";

export const SocialFacebookMessengerIcon = iconFactory("SocialFacebookMessengerIcon", LTR);
